import { browser } from '$app/environment';
import { api } from '$lib/api';

class Wishlisted {
  ids = $state([] as number[]);
  fetched = $state(false);

  add(id: number) {
    if (!this.ids.includes(id)) {
      this.ids.push(id);
    }
  }

  async fetch() {
    if (!browser || this.fetched) {
      return;
    }
    this.fetched = true;
    try {
      const ids = await api<number[]>(fetch, '/v2/wishlist/ids/');
      this.ids = ids || [];
    } catch (error) {
      console.error('Failed to fetch wishlist:', error);
      this.ids = [];
    }
  }
}

export const wishlisted = new Wishlisted();
